import { useReportMetricsContextV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import SaleCostAdjustmentsReportTableV2 from 'src/tables/SaleCostAdjustmentsReportTable/SaleCostAdjustmentsReportTable';

import { ReportsPageLayout } from '../Reports/ReportsPageLayout';
import * as styles from './ReportsSaleCostAdjustmentsPage.css';

export function ReportsSaleCostAdjustmentsPage() {
  // All the child components treat tempReportConfig as the reportConfig
  // to get its latest state
  const {
    tempReportConfig: reportConfig,
    reportMetrics,
    reportSummary,
    reportValueTypes,
  } = useReportMetricsContextV2();

  return (
    <ReportsPageLayout
      reportConfig={reportConfig}
      reportTable={
        <SaleCostAdjustmentsReportTableV2
          className={styles.table}
          metricsData={reportMetrics}
          summaryData={reportSummary}
          report={reportConfig}
          reportValueTypes={reportValueTypes}
        />
      }
    />
  );
}
